const EN = {
    title: 'Collections',
    table: {
        title: 'Collection list',
        columns: {
            id: 'Operation No.',
            paymentDate: 'Operation date',
            code: 'GP Confirm',
            informedDate: 'Charge date',
            amount: 'Amount',
            barCode: 'Note',
            document: 'INE',
            lastFour: 'Last four',
            status: 'Status'
        },
        info: {
            title: 'Code information:',
            1: 'Nature identification (3 digits)',
            2: 'Client INE (8 digits)',
            3: 'Period YYYYMM (6 digits)',
            4: 'Client identification (6 digits)',
            5: 'Last 4 (4 digits)',
            6: 'Total payment (1 digit)',
            7: 'Amount, 9 integers and 2 decimals (11 digits)',
            8: 'Date YYMMDD (6 digits)'
        },
        status: {
            informed: 'Informed',
            1: 'Pending',
            2: 'Informado',
            3: 'Error'
        },
    }
};

export default EN;
